import { render, staticRenderFns } from "./CreateAlternateMedia.vue?vue&type=template&id=1e6fcdb3&scoped=true&"
import script from "./CreateAlternateMedia.vue?vue&type=script&lang=js&"
export * from "./CreateAlternateMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fcdb3",
  null
  
)

export default component.exports